import { createContext, RefObject, useRef } from 'react'
import { TTemplateDetailContainerContext, TTemplatesContainerContext } from './types'
import { TemplateModel, TTemplateSharePayload } from 'cakemail-ui-components-v2'


export const TemplatesContainerContext = createContext<TTemplatesContainerContext | undefined>(undefined)

export const TemplateDetailContainerContext = createContext<TTemplateDetailContainerContext>({
    template: new TemplateModel({}),
    templateRef: { current: new TemplateModel({}) },
    setTemplate: () => { },
    updateTemplate: () => { },
    handleUnshare: () => { },
    handleShare: () => { return new Promise(() => { }) }
})